import { AxiosRequestConfig } from "axios";
import { QueryParamsForGetRequest } from "@/utils/types";
import { appendQueryToUrl } from "@/utils";
import {
  ContactPersonResponse,
  ContactPersonResponseSchema,
} from "@/services/api/user/contracts";
import { getContactPersonsEndpoint } from "@/services/api/user/endpoints";
import {
  http,
  UpdateContractorPayload,
  UpdateContractorResponse,
  getUpdateContractorEndpoint,
} from "@/services";

export const getContactPersonsRequest = (
  { email }: { email: string },
  config?: AxiosRequestConfig,
) =>
  http.get<ContactPersonResponse>(
    getContactPersonsEndpoint,
    { email },
    config,
    undefined,
    ContactPersonResponseSchema,
  );

export const requestSaveContractorsForm = (
  email: QueryParamsForGetRequest,
  data: UpdateContractorPayload,
  config?: AxiosRequestConfig,
) => {
  const url = appendQueryToUrl(getUpdateContractorEndpoint, email);

  return http.put<UpdateContractorResponse>(url, { ...data }, config);
};
